import { jeepRallyApi } from "../api";

const rallyBaseUrl = "/api/v1/rally";
const rankingsBaseUrl = "/api/v1/rankings";

export const getRankingsByEvent = (eventId, params = {}) => {
  const query = {};
  if (params.type) query.type = params.type;
  if (params.typeId) query.typeId = params.typeId;
  if (params.type_id) query.type_id = params.type_id;
  if (params.categoryId) query.categoryId = params.categoryId;
  if (params.category_id) query.category_id = params.category_id;
  if (params.category) query.category = params.category;
  if (params.after_stage === 0 || params.after_stage) {
    query.after_stage = params.after_stage;
  }

  return jeepRallyApi.get(`${rallyBaseUrl}/${eventId}/rankings`, {
    params: query,
  });
};

export const setRankingsByEvent = (eventId, payload) => {
  return jeepRallyApi.post(`${rallyBaseUrl}/${eventId}/rankings`, payload);
};

export const patchRanking = (id, payload) => {
  return jeepRallyApi.patch(`${rankingsBaseUrl}/${id}`, payload);
};

export const deleteRankingsSnapshot = (eventId, params = {}) => {
  const query = {};
  if (params.type) query.type = params.type;
  if (params.typeId) query.typeId = params.typeId;
  if (params.categoryId) query.categoryId = params.categoryId;
  if (params.category) query.category = params.category;
  if (params.after_stage === 0 || params.after_stage) {
    query.after_stage = params.after_stage;
  }

  return jeepRallyApi.delete(`${rallyBaseUrl}/${eventId}/rankings`, {
    params: query,
  });
};
